import { ApplicationElement, html } from '../application_element/element.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import emojiRegex from 'emoji-regex';

const isEmojiRegex = emojiRegex();
const isOnlyEmojisRegex = new RegExp(`^(${isEmojiRegex.source}|\\s)+$`); // \\s signifies all whitespaces, which are allowed in this regex

/**
 * This element will find and wrap emojis with span so they can be styled from the parent.
 * The span will have class emoji-sm (if message contains emojis and other characters) or emoji-lg (if message contains only emojis and whitespaces)
 *
 * @prop text - Text of the message (may or may not contain emojis)
 */

export default class EmojiDetector extends ApplicationElement {
  static properties = {
    text: { type: String },
  };

  createRenderRoot() {
    return this;
  }

  /**@internal*/
  get prepared() {
    const isOnlyEmojis = isOnlyEmojisRegex.test(this.text);
    const cssClass = isOnlyEmojis ? 'emoji-lg' : 'emoji-sm';

    return this.text?.replaceAll(
      isEmojiRegex,
      // This needs to be without new lines or spaces so that css white-space: pre-wrap works
      emoji => `<span class="${cssClass}">${emoji}</span>`
    );
  }

  render() {
    return html`${unsafeHTML(this.prepared)}`;
  }
}

customElements.get('ef-emoji-detector') ||
  customElements.define('ef-emoji-detector', EmojiDetector);
